export default __webpack_public_path__ + "static/media/2023_Januar_Tisch.686bd5d9.webp";